import Vue from 'vue';

export function intlPlural (locale, value, variants, defaultValue = '[pluralization failed ({type})]') {
  const type = (new Intl.PluralRules(locale)).select(value);

  return variants[type]
    ? variants[type].replace('{n}', value)
    : defaultValue.replace('{type}', type);
}

Vue.filter('plural', (value, one, few, many, other, defaultValue = '[pluralization failed ({type})]', locale = 'ru-Ru') => {
  return intlPlural(locale, value, {one, few, many, other}, defaultValue);
});
